export default [
  { name: 'el-icon-platform-eleme', label: 'platform-eleme' },
  { name: 'el-icon-eleme', label: 'eleme' },
  { name: 'el-icon-delete-solid', label: 'delete-solid' },
  { name: 'el-icon-delete', label: 'delete' },
  { name: 'el-icon-s-tools', label: 's-tools' },
  { name: 'el-icon-setting', label: 'setting' },
  { name: 'el-icon-user-solid', label: 'user-solid' },
  { name: 'el-icon-user', label: 'user' },
  { name: 'el-icon-phone', label: 'phone' },
  { name: 'el-icon-phone-outline', label: 'phone-outline' },
  { name: 'el-icon-more', label: 'more' },
  { name: 'el-icon-more-outline', label: 'more-outline' },
  { name: 'el-icon-star-on', label: 'star-on' },
  { name: 'el-icon-star-off', label: 'star-off' },
  { name: 'el-icon-s-goods', label: 's-goods' },
  { name: 'el-icon-goods', label: 'goods' },
  { name: 'el-icon-warning', label: 'warning' },
  { name: 'el-icon-warning-outline', label: 'warning-outline' },
  { name: 'el-icon-question', label: 'question' },
  { name: 'el-icon-info', label: 'info' },
  { name: 'el-icon-remove', label: 'remove' },
  { name: 'el-icon-circle-plus', label: 'circle-plus' },
  { name: 'el-icon-success', label: 'success' },
  { name: 'el-icon-error', label: 'error' },
  { name: 'el-icon-zoom-in', label: 'zoom-in' },
  { name: 'el-icon-zoom-out', label: 'zoom-out' },
  { name: 'el-icon-remove-outline', label: 'remove-outline' },
  { name: 'el-icon-circle-plus-outline', label: 'circle-plus-outline' },
  { name: 'el-icon-circle-check', label: 'circle-check' },
  { name: 'el-icon-circle-close', label: 'circle-close' },
  { name: 'el-icon-s-help', label: 's-help' },
  { name: 'el-icon-help', label: 'help' },
  { name: 'el-icon-minus', label: 'minus' },
  { name: 'el-icon-plus', label: 'plus' },
  { name: 'el-icon-check', label: 'check' },
  { name: 'el-icon-close', label: 'close' },
  { name: 'el-icon-picture', label: 'picture' },
  { name: 'el-icon-picture-outline', label: 'picture-outline' },
  { name: 'el-icon-picture-outline-round', label: 'picture-outline-round' },
  { name: 'el-icon-upload', label: 'upload' },
  { name: 'el-icon-upload2', label: 'upload2' },
  { name: 'el-icon-download', label: 'download' },
  { name: 'el-icon-camera-solid', label: 'camera-solid' },
  { name: 'el-icon-camera', label: 'camera' },
  { name: 'el-icon-video-camera-solid', label: 'video-camera-solid' },
  { name: 'el-icon-camera', label: 'camera' },
  { name: 'el-icon-message-solid', label: 'message-solid' },
  { name: 'el-icon-bell', label: 'bell' },
  { name: 'el-icon-s-cooperation', label: 's-cooperation' },
  { name: 'el-icon-s-order', label: 's-order' },
  { name: 'el-icon-s-platform', label: 's-platform' },
  { name: 'el-icon-s-fold', label: 's-fold' },
  { name: 'el-icon-s-unfold', label: 's-unfold' },
  { name: 'el-icon-s-operation', label: 's-operation' },
  { name: 'el-icon-s-promotion', label: 's-promotion' },
  { name: 'el-icon-s-home', label: 's-home' },
  { name: 'el-icon-s-release', label: 's-release' },
  { name: 'el-icon-s-ticket', label: 's-ticket' },
  { name: 'el-icon-s-management', label: 's-management' },
  { name: 'el-icon-s-open', label: 's-open' },
  { name: 'el-icon-s-shop', label: 's-shop' },
  { name: 'el-icon-s-marketing', label: 's-marketing' },
  { name: 'el-icon-s-flag', label: 's-flag' },
  { name: 'el-icon-s-comment', label: 's-comment' },
  { name: 'el-icon-s-finance', label: 's-finance' },
  { name: 'el-icon-s-claim', label: 's-claim' },
  { name: 'el-icon-s-custom', label: 's-custom' },
  { name: 'el-icon-s-opportunity', label: 's-opportunity' },
  { name: 'el-icon-s-data', label: 's-data' },
  { name: 'el-icon-s-check', label: 's-check' },
  { name: 'el-icon-s-grid', label: 's-grid' },
  { name: 'el-icon-menu', label: 'menu' },
  { name: 'el-icon-share', label: 'share' },
  { name: 'el-icon-d-caret', label: 'd-caret' },
  { name: 'el-icon-caret-left', label: 'caret-left' },
  { name: 'el-icon-caret-right', label: 'caret-right' },
  { name: 'el-icon-caret-bottom', label: 'caret-bottom' },
  { name: 'el-icon-caret-top', label: 'caret-top' },
  { name: 'el-icon-bottom-left', label: 'bottom-left' },
  { name: 'el-icon-bottom-right', label: 'bottom-right' },
  { name: 'el-icon-back', label: 'back' },
  { name: 'el-icon-right', label: 'right' },
  { name: 'el-icon-bottom', label: 'bottom' },
  { name: 'el-icon-top', label: 'top' },
  { name: 'el-icon-top-left', label: 'top-left' },
  { name: 'el-icon-top-right', label: 'top-right' },
  { name: 'el-icon-arrow-left', label: 'arrow-left' },
  { name: 'el-icon-arrow-right', label: 'arrow-right' },
  { name: 'el-icon-arrow-down', label: 'arrow-down' },
  { name: 'el-icon-arrow-up', label: 'arrow-up' },
  { name: 'el-icon-d-arrow-left', label: 'd-arrow-left' },
  { name: 'el-icon-d-arrow-right', label: 'd-arrow-right' },
  { name: 'el-icon-video-pause', label: 'video-pause' },
  { name: 'el-icon-video-play', label: 'video-play' },
  { name: 'el-icon-refresh', label: 'refresh' },
  { name: 'el-icon-refresh-right', label: 'refresh-right' },
  { name: 'el-icon-refresh-left', label: 'refresh-left' },
  { name: 'el-icon-finished', label: 'finished' },
  { name: 'el-icon-sort', label: 'sort' },
  { name: 'el-icon-sort-up', label: 'sort-up' },
  { name: 'el-icon-sort-down', label: 'sort-down' },
  { name: 'el-icon-rank', label: 'rank' },
  { name: 'el-icon-loading', label: 'loading' },
  { name: 'el-icon-view', label: 'view' },
  { name: 'el-icon-c-scale-to-original', label: 'c-scale-to-original' },
  { name: 'el-icon-date', label: 'date' },
  { name: 'el-icon-edit', label: 'edit' },
  { name: 'el-icon-edit-outline', label: 'edit-outline' },
  { name: 'el-icon-folder', label: 'folder' },
  { name: 'el-icon-folder-opened', label: 'folder-opened' },
  { name: 'el-icon-folder-add', label: 'folder-add' },
  { name: 'el-icon-folder-remove', label: 'folder-remove' },
  { name: 'el-icon-folder-delete', label: 'folder-delete' },
  { name: 'el-icon-folder-checked', label: 'folder-checked' },
  { name: 'el-icon-tickets', label: 'tickets' },
  { name: 'el-icon-document-remove', label: 'document-remove' },
  { name: 'el-icon-document-delete', label: 'document-delete' },
  { name: 'el-icon-document-copy', label: 'document-copy' },
  { name: 'el-icon-document-checked', label: 'document-checked' },
  { name: 'el-icon-document', label: 'document' },
  { name: 'el-icon-document-add', label: 'document-add' },
  { name: 'el-icon-printer', label: 'printer' },
  { name: 'el-icon-paperclip', label: 'paperclip' },
  { name: 'el-icon-takeaway-box', label: 'takeaway-box' },
  { name: 'el-icon-search', label: 'search' },
  { name: 'el-icon-monitor', label: 'monitor' },
  { name: 'el-icon-attract', label: 'attract' },
  { name: 'el-icon-mobile', label: 'mobile' },
  { name: 'el-icon-scissors', label: 'scissors' },
  { name: 'el-icon-umbrella', label: 'umbrella' },
  { name: 'el-icon-headset', label: 'headset' },
  { name: 'el-icon-brush', label: 'brush' },
  { name: 'el-icon-mouse', label: 'mouse' },
  { name: 'el-icon-coordinate', label: 'coordinate' },
  { name: 'el-icon-magic-stick', label: 'magic-stick' },
  { name: 'el-icon-reading', label: 'reading' },
  { name: 'el-icon-data-line', label: 'data-line' },
  { name: 'el-icon-data-board', label: 'data-board' },
  { name: 'el-icon-pie-chart', label: 'pie-chart' },
  { name: 'el-icon-data-analysis', label: 'data-analysis' },
  { name: 'el-icon-collection-tag', label: 'collection-tag' },
  { name: 'el-icon-film', label: 'film' },
  { name: 'el-icon-suitcase', label: 'suitcase' },
  { name: 'el-icon-suitcase-1', label: 'suitcase-1' },
  { name: 'el-icon-receiving', label: 'receiving' },
  { name: 'el-icon-collection', label: 'collection' },
  { name: 'el-icon-files', label: 'files' },
  { name: 'el-icon-notebook-1', label: 'notebook-1' },
  { name: 'el-icon-notebook-2', label: 'notebook-2' },
  { name: 'el-icon-toilet-paper', label: 'toilet-paper' },
  { name: 'el-icon-office-building', label: 'office-building' },
  { name: 'el-icon-school', label: 'school' },
  { name: 'el-icon-table-lamp', label: 'table-lamp' },
  { name: 'el-icon-house', label: 'house' },
  { name: 'el-icon-no-smoking', label: 'no-smoking' },
  { name: 'el-icon-smoking', label: 'smoking' },
  { name: 'el-icon-shopping-cart-full', label: 'shopping-cart-full' },
  { name: 'el-icon-shopping-cart-1', label: 'shopping-cart-1' },
  { name: 'el-icon-shopping-cart-2', label: 'shopping-cart-2' },
  { name: 'el-icon-shopping-bag-1', label: 'shopping-bag-1' },
  { name: 'el-icon-shopping-bag-2', label: 'shopping-bag-2' },
  { name: 'el-icon-sold-out', label: 'sold-out' },
  { name: 'el-icon-sell', label: 'sell' },
  { name: 'el-icon-present', label: 'present' },
  { name: 'el-icon-box', label: 'box' },
  { name: 'el-icon-bank-card', label: 'bank-card' },
  { name: 'el-icon-money', label: 'money' },
  { name: 'el-icon-coin', label: 'coin' },
  { name: 'el-icon-wallet', label: 'wallet' },
  { name: 'el-icon-discount', label: 'discount' },
  { name: 'el-icon-price-tag', label: 'price-tag' },
  { name: 'el-icon-news', label: 'news' },
  { name: 'el-icon-guide', label: 'guide' },
  { name: 'el-icon-male', label: 'male' },
  { name: 'el-icon-female', label: 'female' },
  { name: 'el-icon-thumb', label: 'thumb' },
  { name: 'el-icon-cpu', label: 'cpu' },
  { name: 'el-icon-link', label: 'link' },
  { name: 'el-icon-connection', label: 'connection' },
  { name: 'el-icon-open', label: 'open' },

  { name: 'el-icon-turn-off', label: 'turn-off' },
  { name: 'el-icon-set-up', label: 'set-up' },
  { name: 'el-icon-chat-round', label: 'chat-round' },
  { name: 'el-icon-chat-line-round', label: 'chat-line-round' },
  { name: 'el-icon-chat-square', label: 'chat-square' },
  { name: 'el-icon-chat-dot-round', label: 'chat-dot-round' },
  { name: 'el-icon-chat-dot-square', label: 'chat-dot-square' },
  { name: 'el-icon-chat-line-square', label: 'chat-line-square' },
  { name: 'el-icon-message', label: 'message' },
  { name: 'el-icon-postcard', label: 'postcard' },
  { name: 'el-icon-position', label: 'position' },
  { name: 'el-icon-turn-off-microphone', label: 'turn-off-microphone' },
  { name: 'el-icon-microphone', label: 'microphone' },
  { name: 'el-icon-close-notification', label: 'close-notification' },
  { name: 'el-icon-bangzhu', label: 'bangzhu' },
  { name: 'el-icon-time', label: 'time' },
  { name: 'el-icon-odometer', label: 'odometer' },
  { name: 'el-icon-crop', label: 'crop' },
  { name: 'el-icon-aim', label: 'aim' },
  { name: 'el-icon-switch-button', label: 'switch-button' },
  { name: 'el-icon-full-screen', label: 'full-screen' },
  { name: 'el-icon-copy-document', label: 'copy-document' },
  { name: 'el-icon-mic', label: 'mic' },
  { name: 'el-icon-stopwatch', label: 'stopwatch' },
  { name: 'el-icon-medal-1', label: 'medal-1' },
  { name: 'el-icon-medal', label: 'medal' },
  { name: 'el-icon-trophy', label: 'trophy' },
  { name: 'el-icon-trophy-1', label: 'trophy-1' },
  { name: 'el-icon-first-aid-kit', label: 'first-aid-kit' },
  { name: 'el-icon-discover', label: 'discover' },
  { name: 'el-icon-place', label: 'place' },
  { name: 'el-icon-location', label: 'location' },
  { name: 'el-icon-location-outline', label: 'location-outline' },
  { name: 'el-icon-location-information', label: 'location-information' },
  { name: 'el-icon-add-location', label: 'add-location' },
  { name: 'el-icon-delete-location', label: 'delete-location' },
  { name: 'el-icon-map-location', label: 'map-location' },
  { name: 'el-icon-alarm-clock', label: 'alarm-clock' },
  { name: 'el-icon-timer', label: 'timer' },
  { name: 'el-icon-watch-1', label: 'watch-1' },
  { name: 'el-icon-watch', label: 'watch' },
  { name: 'el-icon-lock', label: 'lock' },
  { name: 'el-icon-unlock', label: 'unlock' },
  { name: 'el-icon-key', label: 'key' },
  { name: 'el-icon-service', label: 'service' },
  { name: 'el-icon-mobile-phone', label: 'mobile-phone' },
  { name: 'el-icon-bicycle', label: 'bicycle' },
  { name: 'el-icon-truck', label: 'truck' },
  { name: 'el-icon-ship', label: 'ship' },
  { name: 'el-icon-basketball', label: 'basketball' },
  { name: 'el-icon-football', label: 'football' },
  { name: 'el-icon-soccer', label: 'soccer' },
  { name: 'el-icon-baseball', label: 'baseball' },
  { name: 'el-icon-wind-power', label: 'wind-power' },
  { name: 'el-icon-light-rain', label: 'light-rain' },
  { name: 'el-icon-lightning', label: 'lightning' },
  { name: 'el-icon-heavy-rain', label: 'heavy-rain' },
  { name: 'el-icon-sunrise', label: 'sunrise' },
  { name: 'el-icon-sunrise-1', label: 'sunrise-1' },
  { name: 'el-icon-sunset', label: 'sunset' },
  { name: 'el-icon-sunny', label: 'sunny' },
  { name: 'el-icon-cloudy', label: 'cloudy' },
  { name: 'el-icon-partly-cloudy', label: 'partly-cloudy' },
  { name: 'el-icon-cloudy-and-sunny', label: 'cloudy-and-sunny' },
  { name: 'el-icon-moon', label: 'moon' },
  { name: 'el-icon-moon-night', label: 'moon-night' },
  { name: 'el-icon-dish', label: 'dish' },
  { name: 'el-icon-dish-1', label: 'dish-1' },
  { name: 'el-icon-food', label: 'food' },
  { name: 'el-icon-chicken', label: 'chicken' },
  { name: 'el-icon-fork-spoon', label: 'fork-spoon' },
  { name: 'el-icon-knife-fork', label: 'knife-fork' },
  { name: 'el-icon-burger', label: 'burger' },
  { name: 'el-icon-tableware', label: 'tableware' },
  { name: 'el-icon-sugar', label: 'sugar' },
  { name: 'el-icon-dessert', label: 'dessert' },
  { name: 'el-icon-ice-cream', label: 'ice-cream' },
  { name: 'el-icon-hot-water', label: 'hot-water' },
  { name: 'el-icon-water-cup', label: 'water-cup' },
  { name: 'el-icon-coffee-cup', label: 'coffee-cup' },
  { name: 'el-icon-cold-drink', label: 'cold-drink' },
  { name: 'el-icon-goblet', label: 'goblet' },
  { name: 'el-icon-goblet-full', label: 'goblet-full' },
  { name: 'el-icon-goblet-square', label: 'goblet-square' },
  { name: 'el-icon-goblet-square-full', label: 'goblet-square-full' },
  { name: 'el-icon-refrigerator', label: 'refrigerator' },
  { name: 'el-icon-grape', label: 'grape' },
  { name: 'el-icon-watermelon', label: 'watermelon' },
  { name: 'el-icon-cherry', label: 'cherry' },
  { name: 'el-icon-apple', label: 'apple' },
  { name: 'el-icon-pear', label: 'pear' },
  { name: 'el-icon-orange', label: 'orange' },
  { name: 'el-icon-coffee', label: 'coffee' },
  { name: 'el-icon-ice-tea', label: 'ice-tea' },
  { name: 'el-icon-ice-drink', label: 'ice-drink' },
  { name: 'el-icon-milk-tea', label: 'milk-tea' },
  { name: 'el-icon-potato-strips', label: 'potato-strips' },
  { name: 'el-icon-lollipop', label: 'lollipop' },
  { name: 'el-icon-ice-cream-square', label: 'ice-cream-square' },
  { name: 'el-icon-ice-cream-round', label: 'ice-cream-round' }
]
